module.exports = __webpack_public_path__ + "DINNextLTPro-BoldItalic.woff2?a4126ba42bcc939508e9fe5db88c7e67";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-BoldItalic.woff2
// module id = 1382
// module chunks = 0